(() => {
  if (window.ppHomeReviewsLoaded) return;
  window.ppHomeReviewsLoaded = true;
  const initialize = root => {
    root.querySelectorAll('[data-pp-home-reviews]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('[data-review-track]');
      const controls = section.querySelector('[data-review-controls]');
      const previous = section.querySelector('[data-review-prev]');
      const next = section.querySelector('[data-review-next]');
      const controller = new AbortController();
      const update = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        controls.hidden = max < 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      };
      const move = direction => {
        const item = track.querySelector('article');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 20;
        const step = item.getBoundingClientRect().width + gap;
        const count = Math.max(1, Math.floor((track.clientWidth + gap) / step));
        track.scrollBy({left: direction * step * count, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1), {signal: controller.signal});
      next.addEventListener('click', () => move(1), {signal: controller.signal});
      track.addEventListener('scroll', update, {passive:true, signal:controller.signal});
      const observer = new ResizeObserver(update);
      observer.observe(track); update();
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(section)) return;
        observer.disconnect(); controller.abort();
      }, {signal:controller.signal});
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
